var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRevenue = function SvgRevenue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10.75 1.875a.75.75 0 0 0-1.5 0V3h-.812a3.875 3.875 0 0 0 0 7.75h.812v4.75H8.125a2.375 2.375 0 0 1-2.375-2.375.75.75 0 0 0-1.5 0A3.875 3.875 0 0 0 8.125 17H9.25v1.125a.75.75 0 0 0 1.5 0V17h1.125a3.875 3.875 0 0 0 0-7.75H10.75V4.5h.5a2.375 2.375 0 0 1 2.375 2.375.75.75 0 0 0 1.5 0A3.874 3.874 0 0 0 11.25 3h-.5zM9.25 4.5h-.812a2.375 2.375 0 1 0 0 4.75h.812zm1.5 6.25v4.75h1.125a2.375 2.375 0 1 0 0-4.75z",
    clipRule: "evenodd",
    opacity: 0.7
  })));
};
export default SvgRevenue;